import React, { useMemo } from "react";
import dayjs from "dayjs";
import { DatePicker, Table } from "antd";

const HIDDEN_CONSOLIDATED_COLUMN_KEYS = new Set([
  "specialRatePerMonth",
  "Booking Period",
]);

const InvoiceInventoryList = ({ invoiceData }) => {
  const specialRatePerMonth = invoiceData?.inventories;
  const BookingPeriod = invoiceData?.inventories;
  const isConsolidated = invoiceData?.isConsolidated === true;

  const columns = useMemo(() => {
    const allColumns = [
    {
      title: "Vendor",
      dataIndex: "CodeNo",
      key: "CodeNo",
      align: "center",
      fixed: "left",
      render: (_, record) =>
        record?.isTrading ? record?.ownedBy : record?.CodeNo,
    },
    {
      title: "Location",
      dataIndex: "locationName",
      key: "locationName",
      align: "center",
      render: (text) => (
        <>
          {text}
          <div style={{ width: "200px", height: "1px" }}></div>
        </>
      ),
    },
    {
      title: "Billing Amount",
      dataIndex: "specialRate",
      key: "specialRate",
      align: "center",
      render: (_, record) => {
        return <>{Math.round(record?.amount)}</>; // Make sure to return the JSX
      },
    },
    {
      title: (
        <div style={{ whiteSpace: "pre-line", textAlign: "center" }}>
          Special Rate{"\n"}Per Month
        </div>
      ),
      dataIndex: "specialRatePerMonth",
      key: "specialRatePerMonth",
      align: "center",
      render: (_, record) => {
        // Now fetch data from invoiceData?.inventories
        const inventory = specialRatePerMonth?.find(
          (item) => item?._id === record?._id
        );
        return <>{inventory?.specialRatePerMonth}</>;
      },
    },
    {
      title: "Booking Period",
      dataIndex: "Booking Period",
      key: "Booking Period",
      align: "center",
      render: (_, record) => {
        // Convert dates to DD-MM-YYYY format
        const inventory = BookingPeriod?.find(
          (item) => item?._id === record?._id
        );
        const rangeValue =
          inventory?.startDate && inventory?.endDate
            ? [
                dayjs(inventory.startDate, "YYYY-MM-DD"),
                dayjs(inventory.endDate, "YYYY-MM-DD"),
              ]
            : [];

        return (
          <DatePicker.RangePicker
            value={rangeValue}
            disabled={true}
            format={"DD-MM-YYYY"} // <-- Ensures the displayed format is DD-MM-YYYY
            style={{
              width: "230px",
            }}
          />
        );
      },
    },
    {
      title: "Billing Period",
      dataIndex: "Billing Period",
      key: "Billing Period",
      align: "center",
      render: (_, record) => {
        // Convert dates to DD-MM-YYYY format
        const rangeValue =
          record.startDate && record.endDate
            ? [
                dayjs(record.startDate, "YYYY-MM-DD"),
                dayjs(record.endDate, "YYYY-MM-DD"),
              ]
            : [];

        return (
          <DatePicker.RangePicker
            value={rangeValue}
            disabled={true}
            format={"DD-MM-YYYY"} // <-- Ensures the displayed format is DD-MM-YYYY
            style={{
              width: "230px",
            }}
          />
        );
      },
    },
    {
      title: (
        <div style={{ whiteSpace: "pre-line", textAlign: "center" }}>
          Billing Duration{"\n"}(Days)
        </div>
      ),
      dataIndex: "Billing Duration (Days)",
      key: "Billing Duration (Days)",
      align: "center",
      render: (_, record) => {
        // Use billing period dates from the record itself
        if (record?.startDate && record?.endDate) {
          const duration =
            dayjs(record.endDate).diff(dayjs(record.startDate), "day") + 1;
          return <span>{duration}</span>;
        }
        return <span>-</span>;
      },
    },
    ];

    if (isConsolidated) {
      return allColumns.filter(
        (col) => !HIDDEN_CONSOLIDATED_COLUMN_KEYS.has(col.key)
      );
    }
    return allColumns;
  }, [isConsolidated, specialRatePerMonth, BookingPeriod]);

  const dataSource = invoiceData?.billedInvs;

  const components = {
    header: {
      cell: (props) => (
        <th
          {...props}
          style={{
            ...props.style,
            backgroundColor: "#daeffe",
          }}
        />
      ),
    },
  };

  return (
    <div>
      <Table
        columns={columns}
        dataSource={dataSource}
        rowKey="_id"
        components={components}
        scroll={{ x: "max-content" }}
        pagination={false}
      />
    </div>
  );
};

export default InvoiceInventoryList;
